package `fun`.adaptive.resource.image

object Images